var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CITFDatePicker',{attrs:{"state":_vm.state,"format":"M/D/YYYY","value":_vm.value,"disabled":_vm.disabled,"clearable":false,"range":"","confirm":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }